import { CookieInformation } from 'src/externals/consent/cookie-consent';
import { GA4 } from 'src/externals/tag-manager/models/ga4.model';


export const environment = {
    production: true,
    version: 1,
    klaviyoNewsletterListId: 'VsAW6n',
    consent: (() => {
        GA4.setDataLayer();
        GA4.setConsentMode();
        let consent = CookieInformation.cookieConsentFactory();
        GA4.gtmStart();
        GA4.setLocation();
        GA4.setScript();
        return consent;
    })()
};
